/* eslint-disable @typescript-eslint/no-explicit-any */

import type { ApiError } from 'services/api';

import { AddToastParams } from 'providers/Toast';

export interface BaseEntityLoad {
  load: (params: any) => Promise<any>;

  parseError?: (errorResponse: ApiError) => AddToastParams;

  defaultParser?: (params: any) => any;
}

export type Loaders<Config extends Record<string, BaseEntityLoad>> = {
  [key in keyof Config]: Omit<BaseEntityLoad, 'load' | 'defaultParser'> & {
    load: Config[key]['load'];

    defaultParser?: (data: ReturnType<Config[key]['load']>) => ReturnType<Config[key]['load']>;
  };
};

// get intellisense without needing to define each and every mutation key across all entities
export function getLoaders<Config extends Record<string, BaseEntityLoad>>(
  loaders: Config,
): Loaders<Config> {
  return loaders;
}
